<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @print="print" @execute="execute"
                    @save="save" @del="del" ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" @tab-click="selectInfo" value="0">
                    <el-tab-pane :label="$t('getapi[945]')" name="0">
                        <wTable
                                id="xpane-0"
                                :data="dataSet"
                                :loading="loading"
                                queryData="ProSOReceieveViewInfo"
                                :filter_language="['order_statusname']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no"
                                             :label="$t('getapi[2095]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname"
                                             :label="$t('getapi[552]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_type"
                                             :label="$t('getapi[2097]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_no"
                                             :label="$t('getapi[2098]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_person"
                                             :label="$t('getapi[2099]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_time"
                                             :label="$t('getapi[2100]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_person"
                                             :label="$t('getapi[410]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_time"
                                             :label="$t('getapi[409]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date"
                                             :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person"
                                             :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person"
                                             :label="$t('getapi[1747]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1422]')" name="1">
                        <wTable
                                id="xpane-1"
                                :data="dataSet1"
                                :loading="loading"
                                queryData="ProSOReceieveViewInfo"
                                :filter_language="['order_statusname']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable1"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet1"
                                ref="singleTable1"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no"
                                             :label="$t('getapi[2095]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname"
                                             :label="$t('getapi[2954]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_type"
                                             :label="$t('getapi[2097]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_no"
                                             :label="$t('getapi[2098]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_person"
                                             :label="$t('getapi[2099]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_time"
                                             :label="$t('getapi[2100]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_person"
                                             :label="$t('getapi[2952]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_time"
                                             :label="$t('getapi[2950]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date"
                                             :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person"
                                             :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person"
                                             :label="$t('getapi[1747]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6097]')" name="2">
                        <wTable
                                id="xpane-2"
                                :data="dataSet2"
                                :loading="loading"
                                queryData="ProSOReceieveViewInfo"
                                :filter_language="['order_statusname']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleSelectionChange="handleSelectionChange"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                ref="singleTable2"
                                :checkflg="false"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                header-row-class-name="headerclass"
                                @selection-change="handleSelectionChange"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_no"
                                             :label="$t('getapi[2095]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="order_statusname"
                                             :label="$t('getapi[2954]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_type"
                                             :label="$t('getapi[2097]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_no"
                                             :label="$t('getapi[2098]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_person"
                                             :label="$t('getapi[2099]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="receive_time"
                                             :label="$t('getapi[2100]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_person"
                                             :label="$t('getapi[2952]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_account_time"
                                             :label="$t('getapi[2950]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="finance_date"
                                             :label="$t('getapi[1857]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="keep_person"
                                             :label="$t('getapi[1864]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="regist_person"
                                             :label="$t('getapi[1747]')"></el-table-column>
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="executeFinance" :disabled="true">
                            {{$t('getapi[2106]')}}
                        </el-button>
                        <!--<el-button type="primary" size="mini">调整财务日期
                        </el-button>-->
                        <el-button type="primary" size="mini" @click="updateRemarkSO"
                                   :disabled="dataDetail.Head.order_status != 0">{{$t('getapi[7120]')}}
                        </el-button>
                    </div>
                    <div style="width:840px;min-width:840px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[463]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.order_no"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[1861]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini" :value="expStatus(dataDetail.Head.order_status)"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[2098]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input type="text" size="mini"
                                              v-model="dataDetail.Head.keep_account_no"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[4472]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                    <el-input type="text" v-model="dataDetail.Head.keep_person"
                                              readonly
                                              size="mini"

                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectperson(1)"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.keep_person"
                                              v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[410]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.keep_account_person"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[135]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.keep_account_time" type="datetime"
                                                    size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[2099]') }}</td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.receive_person"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[4470]') }}</td>
                                <td>
                                    <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                    <el-input type="text" v-model="dataDetail.Head.regist_person"
                                              readonly
                                              size="mini"

                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectperson(2)"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input type="text" size="mini" v-model="dataDetail.Head.regist_person"
                                              v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[2100]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.receive_time" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td></td>
                                <td></td>
                                <td>{{ $t('getapi[1862]') }}</td>
                                <td>
                                    <el-input type="text" size="mini"
                                              :value="expFinanceStatus(dataDetail.Head.finance_status)"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[143]') }}</td>
                                <td>
                                    <el-input type="textarea" v-model="dataDetail.Head.remark"></el-input>
                                </td>
                                <td></td>
                                <td>
                                </td>
                                <td>{{ $t('getapi[1857]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.finance_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo1">
                    <el-tab-pane :label="$t('getapi[6805]')" name="0">
                        <div>
                            <el-button type="primary" size="mini" @click="selectSoCode('')"
                                       :disabled="dataDetail.Head.order_status != 0">{{ $t('getapi[878]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.batchdel">{{
                                $t('getapi[1522]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="createSerial" :disabled="!btn.createserial">
                                {{$t('getapi[7121]')}}
                            </el-button>
                        </div>
                        <el-table
                                id="xdetilpane-0"
                                :data="dataDetail.Lists"
                                @selection-change="handleSelectionChangeDetail"
                                :row-class-name="tableRowClassNameDetail"
                                :highlight-current-row="true"
                                :height="tableHeight - 220"
                                header-row-class-name="headerclass"
                                border
                                size="mini"
                                style="width: 100%; margin-top:5px"
                                ref="singleTable3"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="line_no"
                                             :label="$t('getapi[1425]')"></el-table-column>
                            <el-table-column prop="so_code" :label="$t('getapi[4168]')"
                                             width="150">
                                <template scope="scope">
                                    <el-input
                                            v-model="scope.row.so_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                    >
                                        <i class="el-icon-edit el-input__icon" slot="suffix"
                                           @click="selectSoCode(scope)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="schedule_no" :label="$t('getapi[4236]')"></el-table-column>
                            <el-table-column prop="line_status" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    {{expStatus(scope.row.line_status)}}
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code"
                                             :label="$t('getapi[112]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_name"
                                             :label="$t('getapi[116]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version"
                                             :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column prop="batch_no" :label="$t('getapi[1763]')">
                                <template scope="scope">
                                    <el-input v-model="scope.row.batch_no" type="text" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="sequence_no" :label="$t('getapi[1764]')">
                                <template scope="scope">
                                    <el-input v-model="scope.row.sequence_no" type="text" oninput="value=value.replace(/(^\s*)|(\s*$)/g,'')"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="receive_qty" :label="$t('getapi[1628]')">
                                <template scope="scope">
                                    <el-input v-model="scope.row.receive_qty" type="number" autocomplete="off" title=""
                                              @mousewheel.native.prevent></el-input>
                                </template>
                            </el-table-column>                            
                            <el-table-column show-overflow-tooltip prop="measureunit"
                                             :label="$t('getapi[888]')"></el-table-column>
                                             <el-table-column show-overflow-tooltip prop="routremark" :label="$t('getapi[12391]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_model"
                                             :label="$t('getapi[124]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_spec"
                                             :label="$t('getapi[125]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="cuspart_id"
                                             :label="$t('getapi[2390]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="cuspart_name"
                                             :label="$t('getapi[2391]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="item_code"
                                             :label="$t('getapi[6211]')"></el-table-column>
                            <el-table-column prop="issequencetrace" :label="$t('getapi[6872]')">
                                <template scope="scope">
                                    {{scope.row.issequencetrace == 1?$t('getapi[2052]'): $t('getapi[2053]')}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6026]')" name="1">
                        <div>
                            <el-button type="primary" size="mini" @click="batchDelS" :disabled="!btn.batchdels">{{
                                $t('getapi[1522]') }}
                            </el-button>
                        </div>
                        <el-table
                                id="xdetilpane-1"
                                @selection-change="handleSelectionChangeDetailS"
                                :row-class-name="tableRowClassNameDetailS"
                                :data="dataDetail.SLists"
                                :highlight-current-row="true"
                                :height="tableHeight - 220"
                                header-row-class-name="headerclass"
                                border
                                size="mini"
                                style="width: 100%; margin-top:5px"
                                ref="singleTable4"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="relation_line_no"
                                             :label="$t('getapi[6040]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_code"
                                             :label="$t('getapi[112]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="part_version"
                                             :label="$t('getapi[149]')"></el-table-column>
                            <el-table-column prop="serial_no" :label="$t('getapi[1764]')">
                                <template scope="scope">
                                    <el-input v-model="scope.row.serial_no" type="text"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="qty"
                                             :label="$t('getapi[1628]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="measureunit"
                                             :label="$t('getapi[888]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="item_code"
                                             :label="$t('getapi[6211]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="trace_inname"
                                             :label="$t('getapi[6872]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="remark"
                                             :label="$t('getapi[6349]')"></el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">表名/视图名称:{{
                    DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">表名/视图名称:{{
                    DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">表名/视图名称:{{
                    DbTbNames }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProSOReceieveViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4018]')" queryData="ProSOReceieveViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector>
        <!--SO号-->
        <selector :isVisible="false" :isBatch=true :isSplitPage=true :postUrl="'/Inv/ReceieveIn/GetSOPopupDataList'"
                  @callback="getSoCode" ref="socode"></selector>
        <selector :isVisible="false" :isBatch=true :isSplitPage=true :postUrl="'/Inv/ReceieveIn/GetSOPopupDataList'"
                  @callback="getSoCode" ref="socodesingle"></selector>
        <!--选择货位号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Action/GetInReceieveInPopupList'"
                  @callback="getcargo" ref="cargo"></selector>
        <!--选择生产入库单单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Inv/Action/GetInReceieveInPopupDataList'" @callback="getorderno" ref="orderno"></selector>

        <el-dialog v-dialogDrag :visible.sync="isShowSerial" :title="$t('getapi[7122]')" width="30%"
                   :close-on-click-modal="false">
            <div>
                <table>
                    <tr>
                        <td style="width:60px">{{ $t('getapi[6040]') }}</td>
                        <td style="width:100px;">
                            <el-input v-model="dataDetailSerial.relation_line_no" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td style="width:60px">{{ $t('getapi[6052]')}}</td>
                        <td style="width:100px;">
                            <el-input v-model="dataDetailSerial.prefix" type="text" size="mini"
                                      :readonly="!btn.istracein" :class="{'readO':!btn.istracein}"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[112]') }}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.part_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[7124]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.digit" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      size="mini" :readonly="!btn.istracein" :class="{'readO':!btn.istracein}"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[149]') }}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.part_version" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[7125]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.start" type="number" autocomplete="off" title="" @mousewheel.native.prevent
                                      size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[888]') }}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.measureunit" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{ $t('getapi[7126]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.count" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[895]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.item_code" type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                        <td>{{$t('getapi[7127]')}}</td>
                        <td>
                            <el-input v-model="dataDetailSerial.postfix" type="text" size="mini"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{ $t('getapi[7123]')}}</td>
                        <td>
                            <el-input :value="dataDetailSerial.trace_in == 0?$t('getapi[2053]'):$t('getapi[2052]')"
                                      type="text" size="mini"
                                      :readonly="true" class="readO"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowSerial = false" size="mini">{{$t('getapi[6]')}}</el-button>
				<el-button type="primary" @click="confirmCreate(0)" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="isShowExecute" width="80%" :close-on-click-modal="false"
                   :show-close="false">
            <table>
                <tr>
                    <td style="width:60px">{{ $t('getapi[5015]') }}</td>
                    <td style="width:150px;">
                        <!--<el-input type="text" size="mini" v-model="dataDetailExecute.Head.order_no" :disabled="true"></el-input>-->
                        <el-input type="text" v-model="dataDetailExecute.Head.order_no"
                                  readonly
                                  class="mcolor"
                                  size="mini"
                        >
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectorderno"></i>
                        </el-input>
                    </td>
                    <td style="width:100px;"> <el-button type="primary" size="mini" @click="copyCargo()">{{ $t('getapi[11503]') }}</el-button></td>
                </tr>
            </table>
            <el-table
                    :data="dataDetailExecute.List"
                    :highlight-current-row="true"
                    :height="tableHeight - 255"
                    border
                    size="mini"
                    style="width: 100%; margin-top:5px"
                    header-row-class-name="headerclass"
            >
                <el-table-column type="selection" v-if="false"></el-table-column>
                <el-table-column show-overflow-tooltip prop="exclusively_id"
                                 :label="$t('getapi[3137]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"
                                 align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>                
                <el-table-column show-overflow-tooltip prop="line_statusname"
                                 :label="$t('getapi[552]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="batch_no" :label="$t('getapi[1763]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="sequence_no" :label="$t('getapi[1764]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="last_routing_sequence_no" :label="$t('getapi[10311]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="last_workproc_name" :label="$t('getapi[10312]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="receive_qty" :label="$t('getapi[1628]')"
                                 align="right"></el-table-column>
                
                <el-table-column show-overflow-tooltip prop="measureunit" :label="$t('getapi[888]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="model" :label="$t('getapi[124]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="spec" :label="$t('getapi[125]')"></el-table-column>
                <el-table-column prop="cargo_position" :label="$t('getapi[1842]')">
                    <template scope="scope">
                        <el-input type="text" v-model="scope.row.cargo_position"
                                  readonly
                                  class="mcolor"
                                  size="mini"
                        >
                            <i class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargo(scope)"></i>
                        </el-input>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowExecute = false" :disabled="!btn.closeExecute">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="executeSave" :disabled="!btn.executeSave" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import {Loading} from 'element-ui';

    export default {
        name: '2_invreceievein',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 全部
                dataSet1: [], // 生成
                dataSet2: [], // 关闭
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_invreceievein'), // 当前页数据量
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('2_invreceievein1'), // 当前页数据量
                SelectIndex: 0, //当前页面
                RightSelectIndex: '0',
                pageSize2: this.$http.getPageSize('2_invreceievein2'), // 当前页数据量
                pageIndex2: 1, // 当前页
                total: 0, // 全部数据总量
                total1: 0, // 生成数据总量
                total2: 0, // 关闭数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                selectData: [], // 多选数组
                dataDetail: {
                    Head: {},
                    Lists: [],
                    SLists: []
                },// 明细
                personType: 1,
                rowindex: -1,
                oneormore: 1,
                selectDataDetail: [],
                isShowSerial: false,
                dataDetailSerial: {},
                selectDataDetailS: [],
                isShowExecute: false, // 是否展示执行弹窗
                dataDetailExecute: {
                    Head: {},
                    Lists: [],
                },
                rowindexcargo: -1,
                btn: {
                    batchdel: false,
                    createserial: false,
                    batchdels: false,
                    istracein: false, //生成序列号时是否追溯
                    closeExecute: true,
                    executeSave: true,
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'prorelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            'dataDetail.Lists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
            'dataDetail.SLists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('2_invreceievein', that)
            that.userData = sessionStorage.getItem('userData');
            that.user = that.userData.username
            that.$limits.dragControllerDiv();
            that.confirmAdd()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
                that.$refs.singleTable3.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop3 = res.target.scrollTop
                },false)
                that.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop4 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                    this.$refs.singleTable3.bodyWrapper.scrollTop =this.scrollTop3;
                    this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProSOReceieveViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4018]"),this.$t("getapi[6588]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (!this.$limits.menuvisible("plv2", 188, 1)) {
                    if (that.$limits.ReadOnlyRightsView('plv2', 186, 1, that.total)) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    //操作权限-查询级别
                    var limits = that.$limits.OperationAuthorityView('plv2', 186, 1, that.total);
                    // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                    switch (limits) {
                        case -1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -2:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 2:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -3:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                            break;
                        case 3:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        default:
                            break;
                    }
                } else {
                    if (that.$limits.authority('plv2', 188, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 188, 1) == 2) {
                        if (that.$limits.authority('plv3', 188, 1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 188, 1) == 1) {
                            //编辑级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 188, 1) == 2) {
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                                if (that.dataDetail.Head.order_status > 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,print,del');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                if (that.dataDetail.Head.order_status == 0 && that.dataDetail.Head.order_no != '') {
                    if (that.$limits.authority('plv2', 293, 1) > 0) {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', true);
                    } else {
                        that.$refs.SetBtn.SetOneBtnEnable('execute', false);
                    }
                }
                that.btnauthority()
            },
            btnauthority() {
                let that = this
                that.btn.batchdel = false
                that.btn.batchdels = false
                that.btn.createserial = false
                if (that.dataDetail.Head.order_status == 0) {
                    if (that.selectDataDetail.length > 0) {
                        if (that.selectDataDetail.length == 1 && that.selectDataDetail[0].issequencetrace == 1) {
                            that.btn.createserial = true
                        }
                        that.btn.batchdel = true
                    }
                    if (that.selectDataDetailS.length > 0) {
                        that.btn.batchdels = true
                    }
                }
            },
            tableRowClassNameDetail({row, rowIndex}) {
                row.index = rowIndex;
            },
            tableRowClassNameDetailS({row, rowIndex}) {
                row.index = rowIndex;
            },
            handleSizeChange(val) {
                let that = this;
                if (that.SelectIndex == 1) {
                    that.pageSize1 = val;
                    this.$http.savePageSize('2_invreceievein1',val)
                } else if (that.SelectIndex == 2) {
                    that.pageSize2 = val;
                    this.$http.savePageSize('2_invreceievein2',val)
                } else {
                    that.pageSize = val;
                    this.$http.savePageSize('2_invreceievein',val)
                }
                that.getView();
                that.authority();
            },
            handleCurrentChange(val) {
                let that = this;
                if (that.SelectIndex == 0) {
                    that.pageIndex = val;
                } else if (that.SelectIndex == 1) {
                    that.pageIndex1 = val;
                } else if (that.SelectIndex == 2) {
                    that.pageIndex2 = val;
                }
                that.getView();
                that.authority();
            },
            handleSelectionChange({records}) {
                let that = this;
                console.log('选中触发！' + records)
                that.selectData = [];
                for (let i = 0; i < records.length; i++) {
                    that.selectData.push(records[i]);
                }
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProSOReceieveViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                if (that.SelectIndex == 0) {
                    data.PageIndex = that.pageIndex;
                    data.PageSize = that.pageSize;
                } else if (that.SelectIndex == 1) {
                    data.PageIndex = that.pageIndex1;
                    data.PageSize = that.pageSize1;
                } else if (that.SelectIndex == 2) {
                    data.PageIndex = that.pageIndex2;
                    data.PageSize = that.pageSize2;
                }
                that.$http.urlpost('/Inv/ReceieveIn/DataList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        }
                        else {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['index']
                }
                for (let i = 0; i < datacopy.SLists.length; i++) {
                    delete datacopy.SLists[i]['index']
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if (that.addoredit != 1) {
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if (that.addoredit != 1) {
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Inv/ReceieveIn/ExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProSOReceieveViewInfo",
                    fromname: that.$t('getapi[4018]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            selectInfo(tab) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            selectInfo1(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['index']
                }
                for (let i = 0; i < datacopy.SLists.length; i++) {
                    delete datacopy.SLists[i]['index']
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd() {
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.isEdit = false;
                that.isShowEdit = true;
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        order_no: '',
                        order_status: '',
                        order_statusname: '',
                        receive_type: '',
                        receive_type_id: '',
                        close_reason: '',
                        keep_account_no: '',
                        receive_person: '',
                        receive_time: '',
                        keep_account_person: that.user,
                        keep_account_time: '',
                        remark: '',
                        finance_status: -1,
                        finance_date: '',
                        keep_person: '',
                        regist_person: '',
                        update_person: '',
                        update_time: ''
                    },
                    Lists: [],
                    SLists: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            editInfo(row) {
                let that = this
                if (that.code == row.order_no) {
                    return
                }
                if (!this.$limits.menuvisible("plv2", 188, 1)) {
                    return
                }
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['index']
                }
                for (let i = 0; i < datacopy.SLists.length; i++) {
                    delete datacopy.SLists[i]['index']
                }
                if (that.oldDataDetail != JSON.stringify(datacopy)) {
                    that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        closeOnClickModal: false,
                        type: 'warning'
                    })
                        .then(() => {
                            that.iscontinuedblclick = true
                            that.oldrow = row
                            that.code = row.order_no
                            that.getDetail(row.order_no)
                        })
                        .catch(() => {
                            that.iscontinuedblclick = false
                            if (that.SelectIndex == 0) {
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            } else if (that.SelectIndex == 1) {
                                that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                            } else if (that.SelectIndex == 2) {
                                that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                            }
                        });
                } else {
                    that.iscontinuedblclick = true
                    that.oldrow = row
                    that.code = row.order_no
                    that.getDetail(row.order_no)
                }
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 2
                let parm = {
                    Code: code,
                    LangType:that.$processdata.getLang()
                };
                clearTimeout(that.timeId)
                that.timeId = setTimeout(() => {
                    let loadingInstance = Loading.service(Common.maskoption);
                    that.$http.urlpost('/Inv/ReceieveIn/GetSOBillInfoBySoCode', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataDetail = res.DataContent;
                            that.dataDetail.Head.isadd = 0
                            that.oldDataDetail = JSON.stringify(that.dataDetail)
                            that.authority();
                        }
                        loadingInstance.close()
                    });
                }, 100);
            },
            //expStatus
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[441]')//'关闭';
                } else {
                    return '';
                }
            },
            expFinanceStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1901]')//'核算';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            selectperson(val) {
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getperson(data) {
                let that = this
                console.log(data)
                if (that.personType == 1) {
                    that.dataDetail.Head.keep_person = data.name
                } else if (that.personType == 2) {
                    that.dataDetail.Head.regist_person = data.name
                }
            },
            // 新增物料
            selectSoCode(row) {
                let that = this;
                if (row == '') {
                    that.oneormore = 1;
                    that.$refs.socode.clearInput(true);
                } else {
                    that.oneormore = 2;
                    that.rowindex = row.$rowIndex;
                    that.$refs.socodesingle.clearInput(true);
                }
            },
            getSoCode(data) {
                let that = this;
                console.log(data);
                if (that.oneormore == 1) {
                    data = data.filter(item => {
                        return that.dataDetail.Lists.every(item2 => {
                            return item.so_code != item2.so_code
                        });
                    });
                    let dataDetailLineNo = 1
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].line_no >= dataDetailLineNo) {
                            dataDetailLineNo = that.dataDetail.Lists[i].line_no + 1
                        }
                    }
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.Lists = [
                            ...that.dataDetail.Lists,
                            {
                                exclusively_id: '',
                                relation_order_no: '',
                                line_no: dataDetailLineNo++,
                                line_status: 0,
                                line_statusname: '',
                                batch_no: data[i].batch_no,
                                sequence_no: data[i].sequence_no,
                                part_code: data[i].part_code,
                                part_name: data[i].part_name,
                                part_version: data[i].part_version,
                                model: '',
                                spec: '',
                                cargo_position: '',
                                receive_qty: data[i].receive_qty,
                                measureunit: data[i].part_master_unit,
                                assist_measureunit: '',
                                assist_receive_qty: 0,
                                receive_price: 0,
                                routing_sequence_no: data[i].routing_sequence_no,
                                workproc_name: data[i].workproc_name,
                                so_code: data[i].so_code,
                                schedule_no: data[i].schedule_no,
                                line_net_total_amount: 0,
                                unit_price: 0,
                                rec_material_unit: 0,
                                rec_man_unit: 0,
                                rec_charge_unit: 0,
                                rec_material_amount: 0,
                                rec_man_amount: 0,
                                rec_charge_amount: 0,
                                rec_charge_material_unit: 0,
                                rec_charge_material_amount: 0,
                                rec_carry_man_unit: 0,
                                rec_carry_man_amount: 0,
                                rec_carry_charge_unit: 0,
                                rec_carry_charge_amount: 0,
                                rec_carry_material_unit: 0,
                                rec_carry_material_amount: 0,
                                rec_outsource_unit: 0,
                                rec_outsource_amount: 0,
                                item_code: data[i].item_code,
                                trace_in: data[i].trace_in,
                                islotnumbertrace: data[i].islotnumbertrace == true ? 1 : 0,
                                cuspart_id: data[i].cuspart_id,
                                cuspart_name: data[i].cuspart_name,
                                issequencetrace: data[i].issequencetrace == true ? 1 : 0
                            }
                        ];
                    }
                } else {
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (data.so_code == that.dataDetail.Lists[i].so_code) {
                            return
                        }
                    }
                    that.dataDetail.Lists[that.rowindex].exclusively_id = '',
                        that.dataDetail.Lists[that.rowindex].relation_order_no = '',
                        that.dataDetail.Lists[that.rowindex].line_status = 0,
                        that.dataDetail.Lists[that.rowindex].line_statusname = '',
                        that.dataDetail.Lists[that.rowindex].batch_no = data.batch_no,
                        that.dataDetail.Lists[that.rowindex].sequence_no = data.sequence_no,
                        that.dataDetail.Lists[that.rowindex].part_code = data.part_code,
                        that.dataDetail.Lists[that.rowindex].part_name = data.part_name,
                        that.dataDetail.Lists[that.rowindex].part_version = data.part_version,
                        that.dataDetail.Lists[that.rowindex].model = '',
                        that.dataDetail.Lists[that.rowindex].spec = '',
                        that.dataDetail.Lists[that.rowindex].cargo_position = '',
                        that.dataDetail.Lists[that.rowindex].receive_qty = data.receive_qty,
                        that.dataDetail.Lists[that.rowindex].measureunit = data.part_master_unit,
                        that.dataDetail.Lists[that.rowindex].assist_measureunit = '',
                        that.dataDetail.Lists[that.rowindex].assist_receive_qty = 0,
                        that.dataDetail.Lists[that.rowindex].receive_price = 0,
                        that.dataDetail.Lists[that.rowindex].routing_sequence_no = data.routing_sequence_no,
                        that.dataDetail.Lists[that.rowindex].workproc_name = data.workproc_name,
                        that.dataDetail.Lists[that.rowindex].so_code = data.so_code,
                        that.dataDetail.Lists[that.rowindex].schedule_no = data.schedule_no,                        
                        that.dataDetail.Lists[that.rowindex].line_net_total_amount = 0,
                        that.dataDetail.Lists[that.rowindex].unit_price = 0,
                        that.dataDetail.Lists[that.rowindex].rec_material_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_man_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_charge_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_material_amount = 0,
                        that.dataDetail.Lists[that.rowindex].rec_man_amount = 0,
                        that.dataDetail.Lists[that.rowindex].rec_charge_amount = 0,
                        that.dataDetail.Lists[that.rowindex].rec_charge_material_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_charge_material_amount = 0,
                        that.dataDetail.Lists[that.rowindex].rec_carry_man_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_carry_man_amount = 0,
                        that.dataDetail.Lists[that.rowindex].rec_carry_charge_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_carry_charge_amount = 0,
                        that.dataDetail.Lists[that.rowindex].rec_carry_material_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_carry_material_amount = 0,
                        that.dataDetail.Lists[that.rowindex].rec_outsource_unit = 0,
                        that.dataDetail.Lists[that.rowindex].rec_outsource_amount = 0,
                        that.dataDetail.Lists[that.rowindex].item_code = data.item_code,
                        that.dataDetail.Lists[that.rowindex].trace_in = data.trace_in,
                        that.dataDetail.Lists[that.rowindex].islotnumbertrace = data.islotnumbertrace == true ? 1 : 0,
                        that.dataDetail.Lists[that.rowindex].cuspart_id = data.cuspart_id,
                        that.dataDetail.Lists[that.rowindex].cuspart_name = data.cuspart_name,
                        that.dataDetail.Lists[that.rowindex].issequencetrace = data.issequencetrace == true ? 1 : 0
                }
            },
            handleSelectionChangeDetail(val) {
                // 明细选择
                let that = this;
                that.selectDataDetail = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataDetail.push(val[i]);
                }
                that.btnauthority();
            },
            handleSelectionChangeDetailS(val) {
                // 明细选择
                let that = this;
                that.selectDataDetailS = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectDataDetailS.push(val[i]);
                }
                that.btnauthority();
            },
            batchDel() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            update_time: that.dataDetail.Head.update_time,
                            order_status: that.dataDetail.Head.order_status,
                            List: []
                        };
                        for (let i = that.selectDataDetail.length - 1; i >= 0; i--) {
                            that.dataDetail.Lists.splice(that.selectDataDetail[i].index, 1);
                            for (let j = that.dataDetail.SLists.length - 1; j >= 0; j--) {
                                if ((that.dataDetail.SLists[j].part_code + that.dataDetail.SLists[j].part_version) == (that.selectDataDetail[i].part_code + that.selectDataDetail[i].part_version)) {
                                    that.dataDetail.SLists.splice(j, 1)
                                }
                            }
                            if (that.selectDataDetail[i].exclusively_id != "") {
                                let datatmp = {
                                    exclusively_id: that.selectDataDetail[i].exclusively_id,
                                    line_no: that.selectDataDetail[i].line_no,
                                }
                                parm.List.push(datatmp);
                            }
                        }
                        if (parm.List.length > 0) {
                            that.$http.urlpost('/Inv/ReceieveIn/DelSOReceieveLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            batchDelS() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            update_time: that.dataDetail.Head.update_time,
                            order_status: that.dataDetail.Head.order_status,
                            List: []
                        };
                        for (let i = that.selectDataDetailS.length - 1; i >= 0; i--) {
                            that.dataDetail.SLists.splice(that.selectDataDetailS[i].index, 1);
                            if (that.selectDataDetailS[i].isadd == 0) {
                                let datatmp = {
                                    part_code: that.selectDataDetailS[i].part_code,
                                    part_version: that.selectDataDetailS[i].part_version,
                                    serial_no: that.selectDataDetailS[i].serial_no
                                }
                                parm.List.push(datatmp);
                            }
                        }
                        if (parm.List.length > 0) {
                            that.$http.urlpost('/Inv/ReceieveIn/DelSOReceieveSLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (that.code != '') {
                                        that.getDetail(that.code);
                                    }
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            // 执行记账
            executeFinance() {
                let that = this
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    update_time: that.dataDetail.Head.update_time,
                    order_status: that.dataDetail.Head.order_status
                }
                that.$http.urlpost('/Inv/ReceieveIn/FinanceSOReceieve', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            // 更新关联零件批次号
            updateRemarkSO() {
                let that = this
                let parm = {
                    Code: that.dataDetail.Head.order_no
                }
                that.$http.urlpost('/Inv/ReceieveIn/UpdaeRemarkSOReceieve', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        if (that.code != '') {
                            that.getDetail(that.code);
                        }
                    }
                });
            },
            //生成序列号
            createSerial() {
                let that = this
                if (that.selectDataDetail[0].trace_in == 1) {
                    that.btn.istracein = false
                    let parm = {
                        Code: that.selectDataDetail[0].item_code
                    }
                    that.$http.urlpost('/Inv/ReceieveIn/GetEngItem', parm, function (res) {
                        that.isShowSerial = true
                        that.dataDetailSerial = {
                            relation_line_no: that.selectDataDetail[0].line_no,
                            part_code: that.selectDataDetail[0].part_code,
                            part_version: that.selectDataDetail[0].part_version,
                            measureunit: that.selectDataDetail[0].measureunit,
                            prefix: res.DataContent[0].prefix,
                            digit: 4,
                            start: parseInt(res.DataContent[0].serial_number) + 1,
                            count: that.selectDataDetail[0].receive_qty,
                            postfix: '',
                            item_code: that.selectDataDetail[0].item_code,
                            trace_in: that.selectDataDetail[0].trace_in
                        }
                    });
                } else {
                    that.btn.istracein = true
                    that.isShowSerial = true
                    that.dataDetailSerial = {
                        relation_line_no: that.selectDataDetail[0].line_no,
                        part_code: that.selectDataDetail[0].part_code,
                        part_version: that.selectDataDetail[0].part_version,
                        measureunit: that.selectDataDetail[0].measureunit,
                        prefix: '',
                        digit: '',
                        start: 1,
                        count: that.selectDataDetail[0].receive_qty,
                        postfix: '',
                        item_code: that.selectDataDetail[0].item_code,
                        trace_in: that.selectDataDetail[0].trace_in
                    }
                }
            },
            confirmCreate(val) {
                let that = this
                let parm = {
                    relation_order_no: that.selectDataDetail[0].relation_order_no,
                    so_code: that.selectDataDetail[0].so_code,
                    issequencetrace: that.selectDataDetail[0].issequencetrace,
                    trace_in: that.selectDataDetail[0].trace_in,
                    iscontinue: val,
                    Head: that.dataDetailSerial,
                    SerialList: that.dataDetail.SLists
                }
                that.$http.urlpost('/Inv/ReceieveIn/SOReceieveCreateSerial', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let arr = res.DataContent.SerialList
                        let parm = []
                        for (let i = 0; i < arr.length; i++) {
                            parm = [...parm, {
                                part_code: arr[i].part_code
                            }]
                        }
                        that.checkSoPart(parm, arr)
                    } else if (res.Success > 1) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmCreate(res.Success);
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            checkSoPart(parm, arr) {
                let that = this
                let param = {
                    List: parm,
                    LangType:that.$processdata.getLang()
                }
                that.$http.urlpost('/Inv/ReceieveIn/CheckSOPartReceieve', param, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowSerial = false
                        that.dataDetail.SLists = arr
                    }
                });
            },
            checkDataChange() {
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 188,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for (let i = 0; i < datacopy.Lists.length; i++) {
                    delete datacopy.Lists[i]['index']
                }
                for (let i = 0; i < datacopy.SLists.length; i++) {
                    delete datacopy.SLists[i]['index']
                }
                let flag = that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
            save() {
                let that = this
                that.dataDetail.LangType= that.$processdata.getLang();
                let parm = that.dataDetail
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Inv/ReceieveIn/InvReceivData', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        let parm = res.UniqueNum;
                        that.code = res.UniqueNum
                        that.getDetail(parm);
                    }
                });
            },
            print() {
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                    return;
                }
                this.$confirm(that.$t('getapi[8607]'), that.$t('getapi[194]'), {//要打印DC号嘛?
                    confirmButtonText: that.$t('getapi[2052]'),
                    cancelButtonText: that.$t('getapi[2053]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.$refs.SetBtn.SetOneBtnEnable('print', false);
                        that.loading = true;
                        let parm = {
                            po_no: that.dataDetail.Head.order_no,
                            TemplateName: '15生产入库单_DC.xlsx'
                        };
                        that.$http.urlpost('/Print/ProInPrint', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('print', true);
                            if (res.Success == 1) {
                                let hrefurl = res.Key;
                                window.open(hrefurl);
                            }
                            that.loading = false;
                        });
                    })
                    .catch(() => {
                        that.$refs.SetBtn.SetOneBtnEnable('print', false);
                        that.loading = true;
                        let parm = {
                            po_no: that.dataDetail.Head.order_no,
                            TemplateName: '15生产入库单.xlsx'
                        };
                        that.$http.urlpost('/Print/ProInPrint', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('print', true);
                            if (res.Success == 1) {
                                let hrefurl = res.Key;
                                window.open(hrefurl);
                            }
                            that.loading = false;
                        });
                    });
            },
            execute() {
                let that = this
                that.isShowExecute = true
                that.getInReceieveInInfo(that.dataDetail.Head.order_no)
                that.btn.executeSave = true
            },
            getInReceieveInInfo(code) {
                let that = this
                that.btn.executeSave = true
                let parm = {
                    Code: code
                }
                that.$http.urlpost('/Inv/Action/GetInReceieveInInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetailExecute = res.DataContent
                    }
                });
            },
            // 选择货位
            selectcargo(row) {
                let that = this;
                that.rowindexcargo = row.$index
                that.$refs.cargo.clearInput(true);
            },
            getcargo(data) {
                let that = this
                console.log(data)
                that.dataDetailExecute.List[that.rowindexcargo].cargo_position = data.cargoposition_code
                let parm = {
                    part_code: that.dataDetailExecute.List[that.rowindexcargo].part_code,
                    part_version: that.dataDetailExecute.List[that.rowindexcargo].part_version,
                }
                that.$http.urlpost('/Inv/Action/InReceieveInCheckDefaultCargoPosition', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[3086]'),
                            type: 'warning'
                        })
                            .then(() => {
                                let parm1 = {
                                    part_code: that.dataDetailExecute.List[that.rowindexcargo].part_code,
                                    part_version: that.dataDetailExecute.List[that.rowindexcargo].part_version,
                                    cargo_position: that.dataDetailExecute.List[that.rowindexcargo].cargo_position,
                                    isdefault: 1
                                }
                                that.$http.urlpost('/Inv/Action/InReceieveInSetDefaultPosition', parm1, function (res1) {
                                    if (res1.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                                    }
                                })
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                });
            },
            // 选择生产入库单号
            selectorderno(row) {
                let that = this;
                that.$refs.orderno.clearInput(true);
            },
            getorderno(data) {
                let that = this
                console.log(data)
                that.dataDetailExecute.Head.order_no = data.order_no
                that.getInReceieveInInfo(that.dataDetailExecute.Head.order_no)
            },
            executeSave() {
                let that = this
                let parm = that.dataDetailExecute
                parm.LangType = that.$processdata.getLang()
                that.btn.executeSave = false
                that.btn.closeExecute = false
                that.$http.urlpost('/Inv/Action/ActInReceieveInSaveData', parm, function (res1) {
                    if (res1.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res1.Msg));
                        that.getDetail(that.code);
                    } else {
                        that.btn.executeSave = true
                    }
                    that.btn.closeExecute = true
                })
            },
            del() {
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            update_time: that.dataDetail.Head.update_time
                        };
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Inv/ReceieveIn/DelSOReceieve', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView();
                                that.confirmAdd();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if (!that.iscontinuedblclick) {
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit() {
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            copyCargo(){
                let that = this
                if(that.dataDetailExecute.List.length>0){
                    if(that.$limits.fnIsEmpty(that.dataDetailExecute.List[0].cargo_position)){
                        return
                    } else {
                        for(let i = 0;i<that.dataDetailExecute.List.length;i++){
                            if(that.$limits.fnIsEmpty(that.dataDetailExecute.List[i].cargo_position)){
                                that.dataDetailExecute.List[i].cargo_position = that.dataDetailExecute.List[0].cargo_position
                            }
                        }
                    }
                } else {
                    that.$message.warning(that.$t('getapi[9036]'))
                }
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .blue {
        background: #9dd9ff;
    }
</style>
